import { render, staticRenderFns } from "./connection-footer.vue?vue&type=template&id=c04b2144&scoped=true&"
import script from "./connection-footer.vue?vue&type=script&lang=ts&"
export * from "./connection-footer.vue?vue&type=script&lang=ts&"
import style0 from "./connection-footer.vue?vue&type=style&index=0&id=c04b2144&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04b2144",
  null
  
)

export default component.exports